import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Radio from "@material-ui/core/Radio";

const MembershipsList = () => {
	const classes = useStyles("BookingFunnel");

	const serviceOptions = [
		{
			name: "Unlimited Yoga Pass",
			details: "Unlimited sessions • 2 services",
			price: "$99 / month",
		},
		{
			name: "3 Lesson Package",
			details: "3 sessions • All services",
			price: "$75",
		},
	];

	const [selectedOption, setSelectedOption] = useState(null);

	const handleRadioChange = (event) => {
		setSelectedOption(event.target.value);
	};

	return (
		<List>
			{serviceOptions.map((option, index) => (
				<ListItem
					key={index}
					button
					onClick={() => setSelectedOption(option.name)}
					classes={{
						root: classes.listItem,
						button: classes.listButton,
						container: classes.listItemContainer,
					}}
					disableGutters
				>
					<ListItemText
						classes={{
							primary: classes.listPrimary,
							secondary: classes.listSecondary,
							multiline: classes.listMultiline,
						}}
						primary={option.name}
						secondary={
							<>
								<Box mb={3}>{option.details}</Box>
								<Box color={"#222 !important"} fontWeight={600}>
									{option.price}
								</Box>
							</>
						}
					/>
					<ListItemSecondaryAction>
						<Box
							display={"flex"}
							flexDirection={"column"}
							justifyContent={"flex-end"}
						>
							<Box display={"flex"} justifyContent={"flex-end"}>
								<Radio
									color="primary"
									edge="end"
									checked={selectedOption === option.name}
									onChange={handleRadioChange}
									value={option.name}
								/>
							</Box>
							<Link style={{ fontSize: 14 }}>View details</Link>
						</Box>
					</ListItemSecondaryAction>
				</ListItem>
			))}
		</List>
	);
};

MembershipsList.propTypes = {};
export default MembershipsList;
